(function () {
  function initSalesRepMap() {
    const panel = document.getElementById('rep-info');
    const usMap = document.getElementById('us-map');
    const canadaMap = document.getElementById('canada-map');

    if (!panel || !usMap || !canadaMap) return;

    const reps = {
      jason: {
        name: "Jason Howell",
        email: "jason@stander.com",
        phone: "435-755-0453 x 130",
        photo: "https://cdn.shopify.com/s/files/1/0697/1729/5354/files/Jason-2026-modified_1.jpg?v=1773680695",
        states: ["AK","HI","WA","OR","CA","AZ","NV","UT","ID","MT","WY","CO","NM","TX","OK","KS","NE","SD","ND","MN","IA","MO","AR","LA"]
      },
      brad: {
        name: "Brad Yeates",
        email: "brad@stander.com",
        phone: "435-755-0453 x 110",
        photo: "https://cdn.shopify.com/s/files/1/0697/1729/5354/files/Brad2026.jpg?v=1773696127",
        states: ["WI","IL","MI","IN","OH","KY","TN","MS","AL","FL","GA","SC","NC","VA","WV","MD","DE","PA","NJ","NY","CT","RI","MA","VT","NH","ME"]
      },
      patrick: {
        name: "Patrick Grove",
        email: "patrick@stander.com",
        phone: "435-755-0453 x 301",
        photo: "https://cdn.shopify.com/s/files/1/0697/1729/5354/files/patrick-2026-modified.jpg?v=1773682055",
        states: ["AB","BC","MB","NB","NL","NS","ON","PE","QC","SK","NT","NU","YT"]
      }
    };

    function initials(name) {
      return name
        .split(' ')
        .map(function(part) { return part.charAt(0); })
        .slice(0, 2)
        .join('')
        .toUpperCase();
    }

    function findRep(code) {
      for (const key in reps) {
        if (reps[key].states.includes(code)) return reps[key];
      }
      return null;
    }

    function renderRep(rep) {
      const photoHtml = rep.photo
        ? '<img class="rep-photo" src="' + rep.photo + '" alt="' + rep.name + '">'
        : '<div class="rep-photo-fallback">' + initials(rep.name) + '</div>';

      const stateList = rep.states
        .map(function(code) { return '<span class="state-pill">' + code + '</span>'; })
        .join('');

      panel.innerHTML =
        photoHtml +
        '<div class="rep-name">' + rep.name + '</div>' +
        '<div class="rep-contact">' +
          '<svg class="rep-contact-icon" viewBox="0 0 24 24" aria-hidden="true"><path d="M20 4H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2Zm0 3.5-8 5-8-5V6l8 5 8-5v1.5Z"/></svg>' +
          '<div><a href="mailto:' + rep.email + '">' + rep.email + '</a></div>' +
        '</div>' +
        '<div class="rep-contact">' +
          '<svg class="rep-contact-icon" viewBox="0 0 24 24" aria-hidden="true"><path d="M6.62 10.79a15.05 15.05 0 0 0 6.59 6.59l2.2-2.2a1 1 0 0 1 1.01-.24c1.12.37 2.33.56 3.58.56a1 1 0 0 1 1 1V20a1 1 0 0 1-1 1C10.85 21 3 13.15 3 4a1 1 0 0 1 1-1h3.5a1 1 0 0 1 1 1c0 1.25.19 2.46.56 3.58a1 1 0 0 1-.24 1.01l-2.2 2.2Z"/></svg>' +
          '<div><a href="tel:' + rep.phone.replace(/[^\d+]/g, '') + '">' + rep.phone + '</a></div>' +
        '</div>' +
        '<div class="rep-serving-title">Serving States / Provinces</div>' +
        '<div class="state-pill-wrap">' + stateList + '</div>';
    }

    function showError(message) {
      panel.innerHTML = '<div class="rep-error">' + message + '</div>';
    }

    let usMapInstance = null;
    let canadaMapInstance = null;

    function clearUSSelection() {
      try {
        if (usMapInstance) {
          usMapInstance.clearSelectedRegions();
        }
      } catch (e) {}
    }

    function clearCanadaSelection() {
      try {
        if (canadaMapInstance) {
          canadaMapInstance.clearSelectedRegions();
        }
      } catch (e) {}
    }

    if (typeof window.jsVectorMap !== 'function') {
      showError('Map library not loaded.');
      return;
    }

    try {
      usMapInstance = new window.jsVectorMap({
        selector: '#us-map',
        map: 'us_merc_en',
        zoomButtons: false,
        zoomOnScroll: false,
        regionStyle: {
          initial: { fill: '#e9ecef', stroke: '#ffffff', strokeWidth: 1.2 },
          hover: { fill: '#01b3ce', cursor: 'pointer' },
          selected: { fill: '#f7941e' },
          selectedHover: { fill: '#f7941e' }
        },
        regionsSelectable: true,
        regionsSelectableOne: true,
        onRegionClick: function (event, code) {
          const state = code.replace('US-', '');
          const rep = findRep(state);
          if (rep) {
            clearCanadaSelection();
            renderRep(rep);
            if (window.innerWidth < 990) {
              panel.scrollIntoView({ behavior: 'smooth', block: 'start' });
            }
          }
        }
      });

      canadaMapInstance = new window.jsVectorMap({
        selector: '#canada-map',
        map: 'canada',
        zoomButtons: false,
        zoomOnScroll: false,
        regionStyle: {
          initial: { fill: '#e9ecef', stroke: '#ffffff', strokeWidth: 1.2 },
          hover: { fill: '#01b3ce', cursor: 'pointer' },
          selected: { fill: '#f7941e' },
          selectedHover: { fill: '#f7941e' }
        },
        regionsSelectable: true,
        regionsSelectableOne: true,
        onRegionClick: function (event, code) {
          const province = String(code).toUpperCase().replace('CA-', '');
          const rep = findRep(province);
          if (rep) {
            clearUSSelection();
            renderRep(rep);
            if (window.innerWidth < 990) {
              panel.scrollIntoView({ behavior: 'smooth', block: 'start' });
            }
          }
        }
      });
    } catch (error) {
      showError('Map initialization failed: ' + error.message);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSalesRepMap);
  } else {
    initSalesRepMap();
  }
})();